// React libraries
import * as React from 'react';
// Custom Styles
import { useStyles } from "./DatePickerModalStyles";
// Material-UI Core
import { Grid } from '@mui/material';
// Material-UI Pickers
import { DatePicker } from '@mui/x-date-pickers';
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from "moment";
import { Modal } from "../../index";
import { GreyButton } from "../../index";
export const DatePickerModal = (props) => {
    const classes = useStyles(props);
    const modalWidth = 310;
    const modalHeight = 455;
    const { isModalOpen, setInitialValue, initialValue, setOpenModalState } = props;
    const [selectedDate, handleDateChange] = React.useState(moment(new Date()).format("DD MMM YYYY"));
    React.useEffect(() => {
        if (initialValue !== "") {
            handleDateChange(initialValue);
        }
    }, [initialValue]);
    return (React.createElement(Modal, { isModalOpen: isModalOpen, width: modalWidth, height: modalHeight },
        React.createElement("div", { className: classes.floatingDiv },
            React.createElement(Grid, { container: true },
                React.createElement(Grid, { item: true, md: 12, className: classes.datePickerDiv },
                    React.createElement(LocalizationProvider, { libInstance: moment, utils: AdapterMoment },
                        React.createElement(DatePicker, { variant: "static", value: selectedDate, onChange: date => handleDateChange(moment(date).format("DD MMM YYYY")) }))),
                React.createElement(Grid, { item: true, md: 6, className: classes.floatingDivBarBottom },
                    React.createElement(GreyButton, { type: "left", onClick: () => { setInitialValue(""); setOpenModalState(false); } }, "Clear")),
                React.createElement(Grid, { item: true, md: 6, className: classes.floatingDivBarBottom },
                    React.createElement(GreyButton, { type: "right", onClick: () => { setInitialValue(selectedDate); setOpenModalState(false); } }, "Done"))))));
};
DatePickerModal.defaultProps = {
    setInitialValue: () => { },
    setOpenModalState: () => { },
    initialValue: "",
};
export default React.memo(DatePickerModal);
